export { default } from './encrypted-image'
